export type WorkflowAccessProps = { readOnly: boolean; scopes: readonly string[] };

export class WorkflowMutationError extends Error {
  constructor(readonly status: number, message: string, readonly code: string) {
    super(message);
  }
}

export function workflowErrorStatus(reason: unknown) {
  return reason && typeof reason === 'object' && 'status' in reason && typeof reason.status === 'number'
    ? reason.status
    : undefined;
}

export function workflowErrorCode(reason: unknown) {
  return reason && typeof reason === 'object' && 'code' in reason && typeof reason.code === 'string'
    ? reason.code
    : undefined;
}

export function isAmbiguousApiMutationFailure(reason: unknown): boolean {
  const status = workflowErrorStatus(reason);
  return status === undefined || status >= 500;
}
